/*!
 * Local Project Js File
 *
 */

window.requestAnimFrame = (function(){
  return  window.requestAnimationFrame       ||
          window.webkitRequestAnimationFrame ||
          window.mozRequestAnimationFrame    ||
          window.oRequestAnimationFrame      ||
          window.msRequestAnimationFrame     ||
          function( callback ){
            window.setTimeout(callback, 1000 / 60);
          };
})();

(function () {

  "use strict";

  var myApp = {

  }

  myApp.init = function() {


    ruralApp.Flexslider.initFlex('.flexslider',{animation: 'fade', controlNav: false});
    ruralApp.MagnificPopup.initMagnific('.gallery', {delegate: 'a', type: 'image', gallery: { enabled:true }});

    // $('.flexslider').flexslider({
    //   animation: "fade"
    // });
    console.log('slick');

    // $('.slick-slider').slick({
    //   infinite: true,
    //   slidesToShow: 5,
    //   slidesToScroll: 1,
    //   dots: true,
    //   variableHeight: false,
    //   variableWidth: false
    // });
  }




  document.addEventListener('DOMContentLoaded', function() {
    myApp.init();
  }, false);


})();
